module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?043774d1de6da96b11c8ade1a61c60cb";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff?v=4.5.95
// module id = XZp0
// module chunks = 1